import SEO from '../../src/components/SEO';
import Home from '../../src/components/ptt/PTTHome';
import NavBar from '../../src/components/NavBar';

function PTTHome() {
  // SEO
  const metaTitle = 'PTT | 全站統計';
  const metaDescription = `
    最潮最先進的台灣社群網站資料分析平台
    功能包含: PTT(批踢踢) / Dcard(狄卡) 使用者 ID 搜尋/ 近期動態
    (推噓回文 發表文章 IP 熱點分析), 文章及版的詳細資料統整,
    以及強大的全站搜尋引擎
  `.replace(/\s/g, '');

  return (
    <>
      <SEO
        title={metaTitle}
        description={metaDescription}
      />
      <NavBar>
        <Home />
      </NavBar>
    </>
  );
}

export default PTTHome;
